import { createSvgIcon } from "@mui/material";

export const FilterIcon = createSvgIcon(
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.375 3.375C5.16586 3.375 3.375 5.16586 3.375 7.375V8.375C3.375 10.5841 5.16586 12.375 7.375 12.375H19.625C21.8341 12.375 23.625 10.5841 23.625 8.375V7.375C23.625 5.16586 21.8341 3.375 19.625 3.375H7.375ZM10.125 7.875C10.125 9.11764 9.11764 10.125 7.875 10.125C6.63236 10.125 5.625 9.11764 5.625 7.875C5.625 6.63236 6.63236 5.625 7.875 5.625C9.11764 5.625 10.125 6.63236 10.125 7.875Z"
      fill="#FF9900"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.375 14.625C5.16586 14.625 3.375 16.4159 3.375 18.625V19.625C3.375 21.8341 5.16586 23.625 7.375 23.625H19.625C21.8341 23.625 23.625 21.8341 23.625 19.625V18.625C23.625 16.4159 21.8341 14.625 19.625 14.625H7.375ZM21.375 19.125C21.375 20.3676 20.3676 21.375 19.125 21.375C17.8824 21.375 16.875 20.3676 16.875 19.125C16.875 17.8824 17.8824 16.875 19.125 16.875C20.3676 16.875 21.375 17.8824 21.375 19.125Z"
      fill="#FF9900"
    />
  </svg>,
  "Filter"
);

export const SearchIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M14.2929 16.7071C13.9024 16.3166 13.9024 15.6834 14.2929 15.2929C14.6834 14.9024 15.3166 14.9024 15.7071 15.2929L19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L14.2929 16.7071Z"
      fill="#FF9900"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11ZM16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11Z"
      fill="#FF9900"
    />
  </svg>,
  "Search"
);

export const PlusIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="w-100 h-100"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>,
  "PlusIcon"
);

export const MinusIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="w-100 h-100"
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>,
  "MinusIcon"
);

export const SortIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      fill="none"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8 20V10m0 10l-3-3m3 3l3-3m5-13v10m0-10l3 3m-3-3l-3 3"
    />
  </svg>,
  "SortIcon"
);

export const FilterSortIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path
      fill="none"
      stroke="white"
      stroke-linecap="round"
      stroke-width="2.15"
      d="M22 7H2m17 5H5m11 5H8"
    />
  </svg>,
  "FilterSortIcon"
);
